import Swiper, { Lazy, Navigation, Pagination } from "swiper";
import Blocks from "../modules/blocks";

const SinglePost = {
  init() {
    SinglePost.events();
    SinglePost.related();
    Blocks.init();
    // SinglePost.comments();
    SinglePost.relatedBlogs();
    SinglePost.initPostComments();
  },

  events() {
    $("body").on("click", ".soc-share", function (e) {
      e.preventDefault();

      let url = $(this).attr("href");

      helpers.share(url);
    });
  },

  related() {
    const newsEl = $(".news-posts");
    if (!newsEl.length) {
      return;
    }

    const navPrev = newsEl.find(".swiper-button-prev");
    const navNext = newsEl.find(".swiper-button-next");

    new Swiper(newsEl.find(".news-slider")[0], {
      slidesPerView: 3,
      spaceBetween: 30,
      modules: [Lazy, Navigation],
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
      navigation: {
        prevEl: navPrev[0],
        nextEl: navNext[0],
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        600: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: 3,
        },
      },
    });
  },

  relatedBlogs() {
    const relBlogsEl = $(".related-blogs");
    if (!relBlogsEl.length) {
      return;
    }

    const navPrev = relBlogsEl.find(".swiper-nav--prev");
    const navNext = relBlogsEl.find(".swiper-nav--next");

    new Swiper(relBlogsEl.find(".swiper")[0], {
      slidesPerView: 3,
      spaceBetween: 30,
      modules: [Lazy, Navigation, Pagination],
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
      navigation: {
        prevEl: navPrev[0],
        nextEl: navNext[0],
      },
      pagination: {
        el: relBlogsEl.find(".swiper-pagination")[0],
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        900: {
          slidesPerView: 3,
        },
      },
    });
  },

  initPostComments() {
    // Like button logic for both parent and replies
    document.querySelectorAll(".like-comment").forEach((btn) => {
      btn.addEventListener("click", function () {
        const commentId = this.dataset.commentId;
  
        if (!commentId) {
          console.warn("No comment ID found for like button.");
          return;
        }
  
        if (localStorage.getItem("liked_comment_" + commentId)) {
          alert("You already liked this comment.");
          return;
        }
  
        const likeCountSpan = this.querySelector(".like-count");
        if (!likeCountSpan) {
          console.warn("Like count span not found.");
          return;
        }
  
        fetch(`${window.ajaxurl}?action=like_comment&comment_id=${commentId}`)
          .then((res) => res.json())
          .then((data) => {
            if (data.success) {
              likeCountSpan.textContent = data.count;
              localStorage.setItem("liked_comment_" + commentId, true);
            } else {
              console.error("Like failed:", data);
            }
          })
          .catch((error) => {
            console.error("AJAX error:", error);
          });
      });
    });
  
    // Reply toggle (optional, WP handles this)
    document.querySelectorAll(".comment-reply-link").forEach((link) => {
      link.addEventListener("click", function () {
        // WP moves the form — but you can still collapse others manually
        document.querySelectorAll(".comment-respond").forEach((form) => {
          form.classList.remove("hidden");
        });
  
        // Delay toggling after WP moves the reply form
        setTimeout(() => {
          const form = document.querySelector(".comment-respond");
          if (form && form.closest(`#comment-${this.dataset.commentid}`)) {
            form.classList.remove("hidden"); // ensure it's visible for clicked reply
          }
        }, 100);
      });
    });
  
    // Show/Hide replies
    document.querySelectorAll(".showReplies").forEach((btn) => {
      btn.addEventListener("click", function () {
        const targetId = this.getAttribute("data-target");
        const replies = document.getElementById(targetId);
        if (replies) {
          replies.classList.toggle("hidden");
        }
      });
    });
  }
  
};

export default SinglePost;
